import React, { useEffect, useState } from "react";

const ColumnFilterInput = ({ column }) => {
  const columnFilterValue = column.getFilterValue();
  const [value, setValue] = useState(columnFilterValue ?? "");

  useEffect(() => {
    setValue(columnFilterValue ?? "");
  }, [columnFilterValue]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      column.setFilterValue(value);
    }, 500);

    return () => clearTimeout(timeout);
  }, [value, column]);

  return (
    <input
      className="form-control form-control-sm"
      value={value}
      onChange={(e) => setValue(e.target.value)}
      placeholder="Search..."
    />
  );
};

export default ColumnFilterInput;
